import { render, staticRenderFns } from "./IQHeader.vue?vue&type=template&id=1597e8de&scoped=true"
import script from "./IQHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./IQHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQHeader.vue?vue&type=style&index=0&id=1597e8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597e8de",
  null
  
)

export default component.exports